import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_why_deeper'

export default function DreamWhyDeeperPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's the deeper reason you're drawn to dream work?",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamWhyDeeper.heading')}
      buttons={[
        {
          text: `🦋 ${t('pages.onboarding.dreamWhyDeeper.options.transformation')}`,
          value: 'I am going through a transformation',
          subtext: t('pages.onboarding.dreamWhyDeeper.subtexts.transformation'),
        },
        {
          text: `🔍 ${t('pages.onboarding.dreamWhyDeeper.options.answers')}`,
          value: 'Seeking answers I cant find awake',
          subtext: t('pages.onboarding.dreamWhyDeeper.subtexts.answers'),
        },
        {
          text: `💫 ${t('pages.onboarding.dreamWhyDeeper.options.intuition')}`,
          value: 'Want to trust my intuition more',
          subtext: t('pages.onboarding.dreamWhyDeeper.subtexts.intuition'),
        },
        {
          text: `🌙 ${t('pages.onboarding.dreamWhyDeeper.options.healing')}`,
          value: 'Processing emotions and healing',
          subtext: t('pages.onboarding.dreamWhyDeeper.subtexts.healing'),
        },
        {
          text: `🌌 ${t('pages.onboarding.dreamWhyDeeper.options.curious')}`,
          value: 'Pure curiosity about my mind',
          subtext: t('pages.onboarding.dreamWhyDeeper.subtexts.curious'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
